import { useEffect } from 'react';
import { Navigate } from 'react-router';
import { ForgotPassword, lastAppKey, mountConsoleApp, NoAccess, ResetPassword, SignIn, useSession } from '@infinix/shell';
import { CATALOG, visibleApps } from '@infinix/registry';
import { accountManifest } from './manifest';
import { NotificationsPage, ProfilePage, RegionalPage, SecurityPage } from './screens';

/**
 * Landing: the app used last (remembered per person, like a suite); otherwise the person's first app (A-11). Every
 * app is its own deployable, so this is a page load into it.
 */
function Landing() {
  const s = useSession();
  const target = (() => {
    if (!s.identity || !s.email) return null;
    const mine = visibleApps(s.identity, CATALOG);
    let last: string | null = null;
    try { last = window.localStorage.getItem(lastAppKey(s.email)); } catch { /* no storage */ }
    const work = mine.filter((a) => !a.everyone);
    // Staff start each session in Ops, at All organizations (owner, 2026-10-18): nothing from the last session.
    if (s.audience === 'staff') return mine.find((a) => a.audience === 'staff' && !a.everyone) ?? work[0] ?? null;
    return mine.find((a) => a.id === last) ?? work.find((a) => a.product) ?? work[0] ?? null;
  })();
  useEffect(() => {
    if (target) window.location.replace(target.basePath);
  }, [target]);
  if (s.status === 'loading') return null;
  if (s.status !== 'signed-in') return <Navigate to="/login" replace />;
  return target ? null : <NoAccess what="any app yet" />;
}

// Sign-in, password recovery and landing sit outside the suite chrome; My account (/account) is an app like any other.
mountConsoleApp({
  outside: [
    { path: '/login', element: <SignIn /> },
    { path: '/login/forgot', element: <ForgotPassword /> },
    { path: '/login/reset', element: <ResetPassword /> },
    { path: '/', element: <Landing /> },
  ],
  apps: [{
    manifest: accountManifest,
    routes: [
      { index: true, element: <ProfilePage /> },
      { path: 'security', element: <SecurityPage /> },
      { path: 'notifications', element: <NotificationsPage /> },
      { path: 'regional', element: <RegionalPage /> },
    ],
  }],
});
